// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__1tIjx","addWidgetButton":"Header_addWidgetButton__1UFVZ","dashboardTabs":"Header_dashboardTabs__3qNt_","active":"Header_active__3vI04"};